import { FormFieldDefinition } from '../../../../../../generic/universal-table/types/form.types'
import { ProductUiRow } from '../types/productTable.types'

export const productTableFormFields: FormFieldDefinition<ProductUiRow>[] = [
  {
    name: 'ProductDesc',
    label: 'שם פריט',
    inputType: 'text',
    required: true,
    placeholder: 'הזן שם פריט',
    validationRules: {
      required: true,
      minLength: 1,
      maxLength: 100,
    },
  },
  {
    name: 'ProductDescEng',
    label: 'שם באנגלית',
    inputType: 'text',
    required: false,
    placeholder: 'Enter product name',
    validationRules: {
      maxLength: 100,
    },
  },
  {
    // getOptions is injected in ProductTableModule.tsx
    name: 'CalculationMethod',
    label: 'אופן חישוב',
    inputType: 'searchable-select',
    required: false,
    defaultValue: 0,
  },
  {
    name: 'GeneralProductID',
    label: 'פריט כללי',
    inputType: 'searchable-select',
    required: false,
    defaultValue: 0,
  },
  // {
  //   name: 'ProductFamilyId',
  //   label: 'משפחה',
  //   inputType: 'number',
  //   required: false,
  //   defaultValue: 0,
  //   validationRules: {
  //     min: 0,
  //   },
  // },
  // {
  //   name: 'AccountId',
  //   label: 'חשבון',
  //   inputType: 'number',
  //   required: false,
  //   defaultValue: 0,
  //   validationRules: {
  //     min: 0,
  //   },
  // },
  {
    name: 'ExternalNumber',
    label: 'ברקוד חיצוני',
    inputType: 'text',
    required: false,
    placeholder: 'ברקוד חיצוני',
    validationRules: {
      maxLength: 50,
    },
  },
  // {
  //   name: 'PrintProductDesc',
  //   label: 'שם להדפסה',
  //   inputType: 'text',
  //   required: false,
  //   placeholder: 'שם להדפסה',
  //   validationRules: {
  //     maxLength: 100,
  //   },
  // },
  // {
  //   name: 'PrintProductDesc_CLASS2',
  //   label: 'שם להדפסה (קלאס 2)',
  //   inputType: 'text',
  //   required: false,
  //   placeholder: 'שם להדפסה (קלאס 2)',
  //   validationRules: {
  //     maxLength: 100,
  //   },
  // },
  {
    name: 'Active',
    label: 'פעיל',
    inputType: 'boolean-select',
    required: false,
    defaultValue: true,
  },
  {
    name: 'VAT',
    label: 'מע"מ',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'NoTagCollection',
    label: 'ללא סריקה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'MandatoryWeight',
    label: 'חובת שקילה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Item_For_Stock',
    label: 'לספירת מלאי',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'CollectDeviation',
    label: 'אחוז סטייה מהזמנה (%)',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: {
      min: 0,
    },
  },
  {
    name: 'WastePercent',
    label: 'אחוז פחת (%)',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: {
      min: 0,
      max: 100,
    },
  },
  {
    name: 'PriseListSort',
    label: 'מיון למחירון',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: {
      min: 0,
    },
  },

  {
    name: 'CollectorSort',
    label: 'מיון לליקוט',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: {
      min: 0,
    },
  },
  {
    name: 'ActivityType',
    label: 'סוג פעילות',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: {
      min: 0,
    },
  },
]
